module.exports = __webpack_public_path__ + "static/media/fingerprint.aa42b4f8.png";